<template>
  <div class="locale d-flex align-items-center position-absolute">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM9.71 19.667C8.72341 17.5743 8.15187 15.3102 8.027 13H4.062C4.25659 14.5389 4.89392 15.9882 5.89657 17.1717C6.89922 18.3552 8.22401 19.2221 9.71 19.667ZM10.03 13C10.181 15.439 10.878 17.73 12 19.752C13.1523 17.6766 13.8254 15.3695 13.97 13H10.03ZM19.938 13H15.973C15.8481 15.3102 15.2766 17.5743 14.29 19.667C15.776 19.2221 17.1008 18.3552 18.1034 17.1717C19.1061 15.9882 19.7434 14.5389 19.938 13ZM4.062 11H8.027C8.15187 8.68979 8.72341 6.42569 9.71 4.333C8.22401 4.77788 6.89922 5.64475 5.89657 6.8283C4.89392 8.01184 4.25659 9.4611 4.062 11ZM10.031 11H13.969C13.8248 8.6306 13.152 6.32353 12 4.248C10.8477 6.32345 10.1746 8.63052 10.03 11H10.031ZM14.29 4.333C15.2766 6.42569 15.8481 8.68979 15.973 11H19.938C19.7434 9.4611 19.1061 8.01184 18.1034 6.8283C17.1008 5.64475 15.776 4.77788 14.29 4.333Z" fill="#999999"/>
    </svg>
      <div class="dropdown">
          <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ lang }}
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a v-for="(lang, i) in langs" :key="`Lang${i}`" class="d-block dropdwn-item" :class="$i18n.locale === lang.code ? 'active-lang' : ''" href="#" @click="changeLocale(lang)">{{ lang.name }}</a>
          </div>
      </div>
  </div>
</template>

<script>
import { getSupportedLocales } from "@/util/i18n/supported-locales"
import supportedLocales from "@/config/supported-locales"
export default {
    name: 'locale-dropdown',

    data () {
        return {
            langs: getSupportedLocales(),
            lang: supportedLocales[this.$i18n.locale],
        }
    },
    methods: {
        changeLocale(lang) {
            this.$i18n.locale = lang.code
            this.lang = lang.name
        }
    }
}
</script>

<style lang="scss" scoped>
.locale {
  right: 17vw;
  top: 60px;
  color: #1E86EA;
}
@media (max-width: 700px) {
  .locale {
    right: 9vw;
  }
}
.dropdown-toggle {
  box-shadow: none;
  padding: 5px;
}
.dropdown-toggle::after {
  content: none;
}
.dropdown-menu {
  min-width: 0;
  padding: 0;
}
.dropdwn-item {
  padding: 3px 5px;
}
.dropdwn-item:hover {
  background-color: #E9F4FF;
}
.dropdown button {
  color: #1E86EA;
  font-size: 17px;
  font-weight: 600;
}

.dropdown-menu {
    border: none;
    a {
        cursor: pointer;
        border-radius: 8px;
        text-align: center;
        margin-bottom: 2px;
        box-sizing: border-box;
        height: 30px;
        font-size: 17px;
        font-weight: 400;
        line-height: 20px;
        text-decoration: none;
        color: #1E86EA;
    }
}

.active-lang {
    border: 2px solid #E9F4FF;

}
</style>